import React from 'react';
import { FacebookShareButton, LinkedinShareButton, ViberShareButton, EmailShareButton} from 'react-share';
import Button from '@material-ui/core/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Grid from '@material-ui/core/Grid';
import { withStyles } from '@material-ui/core/styles';
import Icon from '@material-ui/core/Icon';
import classNames from 'classnames';
import Fab from '@material-ui/core/Fab';
import Typography from '@material-ui/core/Typography';

const styles = theme => ({
    root: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '6.5px',
        marginBottom: 10
    },
    btnWrapper: { 
        margin: 10
    },
    fab: {
        background: theme.palette.whiteColor.contrastText,
        color: 'gray',
        width: 38,
        height: 38,
        boxShadow: 'none'
    },
    customIcon: {
        color: '#808080'
    }
})
class OldShareButtons extends React.Component{
    render() {
        const { item, url, classes } = this.props;
        return(
            <Grid
                style={{ margin: '50px 0px 20px' }}
                container
                direction="row"
                justify="center"
                alignItems="center"

            >
                {/*E-Mail*/}
                <Grid item xs={6} sm={3} md={3} lg={2} style={{textAlign: 'center'}}>
                    <EmailShareButton
                      url={`${process.env.BACKEND_URL}${url.asPath}`}
                      windowWidth={750}
                      windowHeight={600}
                    >
                        <div className={classNames(classes.btnWrapper, 'email-share-btn-track-gtm')}>
                            <Button variant="contained" size="medium" color="primary" classes={{root: classes.customButton, label: classes.buttonLabel }} style={{background: '#808080'}}>
                                <div className={classes.iconWrapper}>
                                    <Icon style={{color: '#808080', fontSize: 16, paddingTop: 2}}>email</Icon>
                                </div>
                                <span className={classes.textShare}>Share</span>
                            </Button>
                        </div>
                    </EmailShareButton>
                </Grid>

                {/*Viber*/}
                <Grid item xs={6} sm={3} md={3} lg={2} style={{textAlign: 'center'}}>
                  <ViberShareButton url={`${process.env.BACKEND_URL}${url.asPath}`} title={item.title}>
                      <div className={classNames(classes.btnWrapper, 'viber-share-btn-track-gtm')}>
                          <Button variant="contained" size="medium" color="primary" classes={{root: classes.customButton, label: classes.buttonLabel }} style={{background: '#7e32b2'}}>
                              <div className={classes.iconWrapper}>
                                  <FontAwesomeIcon icon={['fab', 'viber']} style={{color: '#7e32b2'}} />
                              </div>
                              <span className={classes.textShare}>Share</span>
                          </Button>
                      </div>
                  </ViberShareButton>
                </Grid>

                {/*LinkIn*/}
                <Grid item xs={6} sm={3} md={3} lg={2} style={{textAlign: 'center'}}>
                    <LinkedinShareButton
                         url={`${process.env.BACKEND_URL}${url.asPath}`}
                         windowWidth={750}
                         windowHeight={600}
                    >
                        <div className={classNames(classes.btnWrapper, 'linkedIn-share-btn-track-gtm')}>
                            <Button variant="contained" size="medium" color="primary" classes={{root: classes.customButton, label: classes.buttonLabel }} style={{background: '#006cc6'}}>
                                <div className={classes.iconWrapper}>
                                    <FontAwesomeIcon icon={['fab', 'linkedin-in']} style={{color: '#006cc6'}} />
                                </div>
                                <span className={classes.textShare}>Share</span>
                            </Button>
                        </div>
                    </LinkedinShareButton>
                </Grid>
                
                {/*Facebook*/}
                <Grid item xs={6} sm={3} md={3} lg={2} style={{textAlign: 'center'}} >
                    <FacebookShareButton url={`${process.env.BACKEND_URL}${url.asPath}`}>
                        <div className={classNames(classes.btnWrapper, 'fb-share-btn-track-gtm')} >
                            <Button variant="contained" classes={{root: classes.customButton, label: classes.buttonLabel }} size="medium" style={{background: '#014ca9'}}>
                                <div className={classes.iconWrapper}>
                                    <FontAwesomeIcon icon={['fab', 'facebook-f']} style={{color: '#014ca9'}} />
                                </div>
                                <span className={classes.textShare}>Share</span>
                            </Button>
                        </div>
                    </FacebookShareButton>
                </Grid>

            </Grid>
        )
    }
} 
class ShareButtons extends React.Component{
    render() {
        const { item, url, classes } = this.props;
        return(
            <div className={classes.root} style={{ background: item.category ? item.category.color : '#F9461E' }}>
               <Typography
                    variant="body1"
                    component="p"
                    style={{
                        fontSize: 24,
                        color: '#fff',
                        fontWeight: 'bold',
                        lineHeight: '31px',
                        marginRight: 10
                    }}
                >
                    Share
                </Typography>
               
                    <FacebookShareButton url={`${process.env.BACKEND_URL}${url.asPath}`}>
                        <div className={classNames(classes.btnWrapper, 'fb-share-btn-track-gtm')} >
                        <Fab size="medium" aria-label="Add" className={classes.fab}>
                            <FontAwesomeIcon icon={['fab', 'facebook-f']} className={classes.customIcon} />
                            </Fab>
                        </div>
                    </FacebookShareButton>
                  
                    <EmailShareButton
                      url={`${process.env.BACKEND_URL}${url.asPath}`}
                      windowWidth={750}
                      windowHeight={600}
                    >
                        <div className={classNames(classes.btnWrapper, 'email-share-btn-track-gtm')}>   
                            <Fab color="primary" size="medium" aria-label="Add" className={classes.fab}>
                                <Icon className={classes.customIcon}>email</Icon>
                            </Fab>
                        </div>
                    </EmailShareButton>
                    <ViberShareButton url={`${process.env.BACKEND_URL}${url.asPath}`} title={item.title}>
                        <div className={classNames(classes.btnWrapper, 'viber-share-btn-track-gtm')}>
                            <Fab color="primary" size="medium" aria-label="Add" className={classes.fab}>
                                <FontAwesomeIcon icon={['fab', 'viber']} className={classes.customIcon}  />
                            </Fab>
                            
                        </div>
                    </ViberShareButton>
                    <LinkedinShareButton
                         url={`${process.env.BACKEND_URL}${url.asPath}`}
                         windowWidth={750}
                         windowHeight={600}
                    >
                        <div className={classNames(classes.btnWrapper, 'linkedIn-share-btn-track-gtm')}>
                            <Fab color="primary" size="medium" aria-label="Add" className={classes.fab}>
                                <FontAwesomeIcon icon={['fab', 'linkedin-in']} className={classes.customIcon} />
                            </Fab>
                        </div>
                    </LinkedinShareButton>
            </div>
        )
    }
} 
export default withStyles(styles)(ShareButtons);
